$(function () {
    const $root = $('html');
    const js_pageScroll = $(window);   // or $('.js_scrollbar')

    var rx = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;

    // ----- get the width and visibility of the included scrollbar
    $(window).on('resize', function () {
        var div = document.createElement('div');

        div.classList.add('if-scroll');
        div.style.overflowY = 'scroll';
        div.style.width = '50px';
        div.style.height = '50px';
        div.style.visibility = 'hidden';
        document.body.appendChild(div);
        let scrollWidth = div.offsetWidth - div.clientWidth;

        document.body.removeChild(div);

        (scrollWidth > 0) ? $root.addClass('scroll_is-visible') : $root.removeClass('scroll_is-visible');

    });
    // ----- get the width and visibility of the included scrollbar end

    // easy load redirectPage

    /*if (window.matchMedia('(max-width: 865px)').matches) {

        $(".loaderArea").fadeOut(250, function () {
            $(this).removeAttr('style').removeClass('is_active')
        });
        $("a[href*='/']").click(function (event) {
            event.preventDefault();
            const linkLocation = this.href;
            if (linkLocation.indexOf('#') < 0) {
                $(".loaderArea").addClass('is_active').fadeIn(300, () => {
                    window.location = linkLocation;
                })
            }
        });
    }*/

    // easy load redirectPage END


    // ----- hover menu
    (function () {

        const js_burger = $('.js_burger');

        js_burger.on('click', function () {
            $('html').toggleClass('menu-is-active');
        });

        $('.js_burger, .js_main_menuContainer, .js_btnAsideShow, .js_aside_left').on('click', function (e) {
            e.stopPropagation();
        });

        $('body').on('click', function () {
            $('html').removeClass('menu-is-active scroll_stop');
            $('.js_aside_left').removeClass('is_show');
        });

        $('.js_menuItem__icn').on('click', function () {
            $(this).parents('.js_menuItem').find('.js_menuItem__dropdown').addClass('is_open');
        });
        $('.js_menuItem__icnBack').on('click', function () {
            $(this).parents('.js_menuItem__dropdown').removeClass('is_open')
        });

        $('.js_menuItem__icnBack_2').on('click', function () {
            $('.js_hoverNavigation__btn ').removeClass('is_active');
            $(this).parent().removeClass('is_open'); //js_hoverContent__item
            $('.js_menuItem__dropdown ').removeAttr('style');
        });


        var js_loginClone = $('.js_login').clone().addClass('is_clone');
        var js_wishlistClone = $('.js_wishlist').clone().addClass('is_clone');

        var header = $('.header__inner')
        var width = $(window).width() - 1;
        $(window).on('resize', function () {
            if ($(this).width() !== width) {
                width = $(this).width();
                if (window.matchMedia('(min-width: 1286px)').matches) {
                    $('html').removeClass('menu-is-active');

                    $('.js_menuItem__dropdown, .js_hoverContent__item ').removeClass('is_open').removeAttr('style');

                    // $('.js_menuItem').on("mouseenter", function () {
                    //     $(".js_menu").addClass('is_hover');
                    // });

                    /*$('.js_menuItem').on("mouseleave", function () {
                        $(".js_menu").removeClass('is_hover');
                    });*/

                    $(".js_hoverNavigation").on('mouseenter mouseleave', '.js_hoverNavigation__btn:not(.is_active)', function () {
                    // $(".js_hoverNavigation").on('click', '.js_hoverNavigation__btn:not(.is_active)', function () {
                        switchMenu($(this));
                    });
                    $('.js_hoverNavigation__btn').removeClass('is_active');
                    $('.js_hoverContent__item').removeClass('is_open');
                    $('.js_menuItem__dropdown').removeAttr('style');
                } else {

                    $(".js_hoverNavigation").off('mouseenter mouseleave').on('click', '.js_hoverNavigation__btn:not(.is_active)', function () {
                        switchMenu($(this));
                        setTimeout(function () {
                            $('.js_menuItem__dropdown ').css({'overflow-y': 'hidden'});
                        }, 300)
                        $('.js_menuItem__dropdown ').animate({scrollTop: 0}, 300);
                    });
                    $('.js_menuItem').off('mouseenter mouseleave')
                    // $(".js_menu").removeClass('is_hover');

                }
                if (window.matchMedia('(max-width: 1285px)').matches) {
                    $('.js_main_menuTopPanel').append(js_loginClone);
                    $('.js_main_menuTopPanel').append(js_wishlistClone);
                } else {
                    // $('.js_cart').before($('.js_login'));
                    // $('.js_cart').before($('.js_wishlist'));
                }
                if (window.matchMedia('(max-width: 865px)').matches) {
                    $('[data-header-div]').remove()

                    header.removeClass('is_fixed')
                    var headerOffsetTop = header.offset().top
                    setTimeout(function () {
                        var headerHeight = parseInt(header.height());
                        var headerDiv = '<div data-header-div style="height: ' + headerHeight + 'px; display: none;"></div>'
                        header.before(headerDiv)
                    }, 0)

                    $(window).stop(true).scroll(function () {
                        var windowScrollTop = $(window).scrollTop();
                        if (windowScrollTop > headerOffsetTop) {
                            $('[data-header-div]').show()
                            header.addClass('is_fixed')
                        } else {
                            $('[data-header-div]').hide()
                            header.removeClass('is_fixed')
                        }
                    })
                    // $('.loaderArea ').removeClass('is_active')
                    // $('.js_mobileSearch').append($('.js_search'));
                    $('[data-sticky-btns]')
                        // .append($('[data-product-options]'))
                        .append($('[data-product-btns]'));

					setTimeout(function () {
						$('.footer').css('padding-bottom', `${$('[data-product-btns]').outerHeight(true)}px`)
					},100)



                } else {
					$('.footer').css('padding-bottom', '')
                    $(window).stop(true).scroll(function () {
                        $('[data-header-div]').remove()
                        header.removeClass('is_fixed')
                    })

                    // $('.header__search').append($('.js_search'));
                    $('.js_mobileSearch').removeAttr('style');

					if ($('[data-product-options]').length) {
						$('[data-product-options]').after($('[data-product-btns]'))
					} else {
						$('.product__remaining-stock').after($('[data-product-btns]'))
					}

                }
            }
        });


        function switchMenu(elm) {
            var n = elm.parents('.js_hoverParent');
            elm.dmtabs2(n);
        }

        $.fn.dmtabs2 = function (n) {
            $(this).addClass("is_active").siblings().removeClass("is_active");
            n.find("> .js_hoverContent > .js_hoverContent__item").eq($(this).index()).fadeIn(0, function () {
                $(this).addClass("is_open");
            }).siblings(".dropdown-content").fadeOut(0, function () {
                $(this).removeClass("is_open");
            })
        }

    })();

    (function () {
        $('.js_search').find('.search__inp')
        let val = $('.js_search').find('.search__inp').val();
        if (val != '') {
            $('.js_search').addClass('is_focus');
        }

        $('.js_search').find('.search__inp').on('keyup', function () {
            val = $(this).val();
            if (val != '') {
                $(this).parents('.js_search').addClass('is_focus');
            } else {
                $(this).parents('.js_search').removeClass('is_focus');
            }
        });
    })();
    // ----- hover menu end

    (function () {
        $('.js_btnSearch').on('click', function () {
            $('.js_mobileSearch').slideToggle('250');
        });
        $('.js_search input[type="search"]').on('focus', function () {
            $('html, body').animate({scrollTop: 0}, 400);
        })
    })();
    // ----- slide close/open
    (function () {
        $('.js_slideToggle').each(function () {
            var $this = $(this);
            var js_slideHead = $(this).find('.js_slideToggle__head');

            var js_showMore = $(this).find('.js_showMore');
            var showItem = js_showMore.data('show');


            js_slideHead.on('click', function () {

                var $parent = $(this).parent();
                var js_slideBody = $parent.find('.js_slideToggle__body');

                if ($parent.hasClass('is_open')) {
                    js_slideBody.stop(true).slideUp('400', function () {
                        $parent.removeClass('is_open');
                    });
                } else {
                    $parent.addClass('is_open');
                    js_slideBody.stop(true).slideDown('400');
                }
            });

            if ($this.hasClass('is_off')) {
                var width = $(window).width() - 1;
                $(window).on('resize', function () {
                    if ($(this).width() !== width) {
                        width = $(this).width();

                        let displayWidth = $this.data('display-width');

                        if (window.matchMedia('(min-width: ' + displayWidth + 'px)').matches) {
                            $this.addClass('is_open is_off');
                        } else if (!$this.hasClass('is_active')) {
                            $this.removeClass('is_open is_off');
                            $('.js_slideToggle__body').removeAttr('style');
                        } else {
                            $this.removeClass('is_off');
                            $('.js_slideToggle__body').removeAttr('style');
                        }
                    }
                });
            } else {

            }

            if (js_showMore.length && showItem !== 'undefined') {
                if (js_showMore.children().length > showItem) {
                    var sum = 0;
                    var itemHeight;
                    for (var i = 0; i < showItem; i++) {
                        itemHeight = js_showMore.children().eq(i).outerHeight(true);
                        sum = sum + itemHeight;
                    }
                    js_showMore.css({'height': sum + 'px'})
                    js_showMore.after($('<button class="zbtn z-show js_showMoreBtn"><span class="z-show__txt">Show more</span></button>'));

                    $('.js_showMoreBtn').on('click', function () {
                        if (js_showMore.innerHeight() == sum) {
                            $('.z-show__txt', this).text('Hide');
                            js_showMore.css({'height': 'auto'})
                        } else {
                            $('.z-show__txt', this).text('Show more');
                            js_showMore.css({'height': sum + 'px'})

                            if ($(window).width() > 1285) {
                                var toTop = $('.main').offset().top;
                                $('html, body').animate({scrollTop: toTop}, 400);
                                return false;
                            } else {
                                $('.js_aside_left').scrollTop(0);
                                $('.aside__modules, .js_aside_left').css({'height': '100vh'})
                                setTimeout(function () {
                                    $('.aside__modules').removeAttr('style')
                                }, 100);
                            }


                        }
                    });


                    $('.js_slideToggle.is_open .js_slideToggle__head').on('click', function () {
                        if (js_showMore.innerHeight() !== sum) {
                            setTimeout(() => {
                                $(this).next().find('.z-show__txt').text('Show more');
                                js_showMore.css({'height': sum + 'px'})
                            }, 400)

                        }
                    })
                }
            }
        });


        $('[data-filter-children]').each(function () {

            if ($('[data-filter-children="body"]', this).find('input').hasClass('is_checked')) {
                $('[data-filter-children="icn"]', this).addClass('is_open')
                $('[data-filter-children="body"]', this).css({'display': 'block'})
            }
        })
        $('[data-filter-children="icn"]').click(function () {
            $(this).toggleClass('is_open');
            $(this).parents('[data-filter-children]').find('[data-filter-children="body"]').stop(true).slideToggle()
        })
    })();
    // ----- slide close/open end

    (function () {
        if ($(".js_btnAsideShow").length) {
            $('.js_btnAsideShow').on('click', function () {
                $('.js_aside_left').addClass('is_show');
                $('html').addClass('scroll_stop');
            })
        }
        if ($(".js_asideBtnClose").length) {
            $('.js_asideBtnClose').on('click', function () {
                $('.js_aside_left').removeClass('is_show');
                $('html').removeClass('scroll_stop');
            })
        }
    })()


    // ----- sliders
    // =========================

    // ----- js_sliderMain
    if ($("div").is(".js_sliderMain")) {
        var js_sliderMain = new Swiper('.js_sliderMain .swiper-container', {
            slidesPerView: 1,
            loop: true,
            speed: 500,
            // autoHeight: true,
            // preloadImages: true,
            // lazy: true,
            autoplay: {
                delay: 20000,
            },
            navigation: {
                nextEl: '.js_sliderMain .swiper-button-next',
                prevEl: '.js_sliderMain .swiper-button-prev',
            },
            pagination: {
                el: '.js_sliderMain .swiper-pagination',
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 1
            },
            on: {
                init: function () {
                    BackgroundCheck.init({
                        targets: '.js_slideshowTarget',
                        images: '.js_slideshowImg'
                    });
                },
                slideChangeTransitionStart: function () {
                    BackgroundCheck.refresh();
                },
                slideChangeTransitionEnd: function () {
                    BackgroundCheck.refresh();
                }
            },
        });
    }
    // ----- js_sliderMain end

    // ----- js_sliderCarousel
    if ($("div").is(".js_sliderCarousel")) {
        $('.js_sliderCarousel').each(function (index, element) {
            const slider = $(element).find('.swiper-container');
            const sliderItem = slider.data('item');
            const sliderLoop = slider.data('loop');
            const centeredSlides = slider.data('slide-center');
            // console.log(centeredSlides);
            // console.log((!(centeredSlides === undefined || centeredSlides === '')));
            const sliderNavigation = $(element).find('.js_sliderCarousel__navigation');
            const sliderPagination = $(element).find('.js_sliderCarousel__navigation');

            var js_sliderCarousel = new Swiper(slider[0], {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: sliderLoop,
                centeredSlides: (!(centeredSlides === undefined || centeredSlides === '')),
                preloadImages: true,
                lazy: true,
                speed: 300,
                threshold: 20,
                updateOnWindowResize: true,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                navigation: {
                    nextEl: sliderNavigation.find('.swiper-button-next')[0],
                    prevEl: sliderNavigation.find('.swiper-button-prev')[0]
                },
                /*pagination: {
                    el: sliderPagination,
                    dynamicBullets: true,
                },*/
                on: {
                    init: function () {
                        setTimeout(function () {
                            js_sliderCarousel.update();
                        }, 1);
                    },
                    slideChange: function () {
                        setTimeout(function () {
                            js_sliderCarousel.update();
                        }, 1);
                    }
                },
                breakpoints: {
                    1156: {
                        slidesPerView: sliderItem,
                        centeredSlides: (!(centeredSlides === undefined || centeredSlides === ''))
                    },
                    1056: {
                        slidesPerView: (sliderItem > 5) ? 4 : sliderItem
                    },
                    801: {
                        slidesPerView: (sliderItem > 5) ? 4 : 3
                    },
                    481: {
                        slidesPerView: 'auto',
                    },
                    321: {
                        slidesPerView: 'auto',
                        centeredSlides: true,
                    }
                }
            });
        });
    }
    // ----- js_sliderCarousel END


    // ----- js_productSlider
    if ($("div").is(".js_productSlider")) {
        if ($(".js_slideYoutube").length) {

            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


            var initPlayer = function (element) {
                var player = element.querySelector('.video-iframe');
                var button = element.querySelector('.video-play');

                var url = element.dataset.id
                var youtybe_id = url.match(rx)[1];
                $(element).find('.video-iframe').css({'background-image': `url(//img.youtube.com/vi/${youtybe_id}/hqdefault.jpg)`});

                var ytplayer = new YT.Player(player, {

                    playerVars: {
                        'autoplay': 0,
                        'modestbranding': 0,
                        'controls': 1,
                        'showinfo': 0
                    },
                    videoId: youtybe_id
                });
                button.addEventListener('click', function () {
                    ytplayer.playVideo();
                    switch (ytplayer.getPlayerState()) {
                        case 1:
                            ytplayer.stopVideo();
                            break;
                        default:
                            ytplayer.playVideo();
                            break;
                    }
                });
                return youtybe_id
            };

        }

        var js_productThumbSlider = new Swiper('.js_productThumbSlider', {
            slidesPerView: 3,
            spaceBetween: 20,
            slideToClickedSlide: true,
            touchRatio: 0.5,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            watchOverflow: true,
            direction: 'vertical',
            breakpoints: {
                1156: {
                    slidesPerView: 5,
                    spaceBetween: 16,
                }
            }
        });
        var js_productSlider = new Swiper('.js_productSlider', {
            slidesPerView: 1,
            spaceBetween: 25,
            updateOnWindowResize: true,
            speed: 500,
            // autoplay: {
            //     delay: 10000,
            // },
            thumbs: {
                swiper: js_productThumbSlider
            },
            navigation: {
                nextEl: '.js_productSlider .swiper-button-next',
                prevEl: '.js_productSlider .swiper-button-prev',
            },
            pagination: {
                el: '.js_productSlider .swiper-pagination',
                clickable: false,
                dynamicBullets: true,
                dynamicMainBullets: 1
            },
            on: {
                slideNextTransitionStart: function () {
                    js_productThumbSlider.slideNext();
                },
                slidePrevTransitionStart: function () {
                    js_productThumbSlider.slidePrev();
                }
            }
        });

        if ($(".js_slideYoutube").length) {
            var youtubeSlideIndex = [];
            for (let i = 0; i < js_productSlider.slides.length; i++) {
                if ($(js_productSlider.slides[i]).hasClass('js_slideYoutube')) {
                    var js_slideYoutube = js_productSlider.slides[i];
                    youtubeSlideIndex.push(i);
                }
            }
            var youtubeThumbSlide = `<div class="slider-box__slide swiper-slide">
									<img src="./image/placeholder.png"
									 	alt="video"
									 	title="video"
									 	class="slider-box__img swiper-lazy js_imgYoutube">
								</div>`

            for (let i = 0; i < youtubeSlideIndex.length; i++) {
                js_productThumbSlider.addSlide(youtubeSlideIndex[i], [
                    youtubeThumbSlide
                ]);
            }

            $('.video-container').each(function (index) {
                var url = $(this).data('id');
                var youtybe_id = url.match(rx)[1];
                $('.js_imgYoutube').eq(index).attr('src', `https://i.ytimg.com/vi/${youtybe_id}/hqdefault.jpg`);
            });

            js_productSlider.update();

            js_productSlider.on('slideChangeTransitionStart', function () {
                var isVideo = js_productSlider.slides[js_productSlider.previousIndex].querySelector('.video-container');
                if (isVideo) {
                    YT.get(isVideo.querySelector('iframe').id).stopVideo();
                }
            });

            window.onYouTubePlayerAPIReady = function () {
                var container = document.querySelectorAll('.video-container');
                for (var i = 0; i < container.length; i++) {
                    initPlayer(container[i])
                }
            };
            if ($('.video-swiper-wrapper .swiper-slide').length < 2) {
                $('.video-ctrl').hide();
            }
        }

        $('.js_optionImage').on('click', function () {
            addCloneSlide();
        });

        $('.js_newSelect select').on('change', function () {
            if ($(this).val() != '') {
                addCloneSlide();
            }
        });

        // $('.js_newSelect select option').each(function () {
        //     if ($(this).attr('src') != 'NA') {
        //
        //
        //     }
        // })

        function addCloneSlide() {
            var js_productSlider_cloneHtml = `<div class="slider-box__slide swiper-slide js_slideClone">
                                                    <img src=""
                                                         data-original-src=""
                                                         alt="${$('.product-main__head--heading').text()}"
                                                         title="${$('.product-main__head--heading').text()}"
                                                         class="slider-box__img swiper-lazy">
                                                </div>`
            var js_productSlider_clone = $(js_productSlider.slides[js_productSlider.activeIndex]).clone().addClass('js_slideClone');
            var js_productThumbSlider_clone = $(js_productThumbSlider.slides[js_productSlider.activeIndex]).clone().addClass('js_slideClone');
            if (js_productSlider.slides.length < 2) {
                js_productSlider.pagination.el.classList.remove('swiper-pagination')
                js_productSlider.pagination.el.classList.remove('slider-box__pagination')
            }
            if ($(js_productSlider.slides[0], js_productThumbSlider.slides[0]).hasClass('js_slideClone')) {
                js_productSlider.removeSlide(0);
                js_productThumbSlider.removeSlide(0);
            }
            if ($(js_productSlider.slides[js_productSlider.activeIndex]).hasClass('js_slideYoutube')) {
                js_productSlider.prependSlide(js_productSlider_cloneHtml);
            } else {
                js_productSlider.prependSlide(js_productSlider_clone);
            }
            js_productThumbSlider.prependSlide(js_productThumbSlider_clone);
            js_productSlider.slideTo(0, 300)
            js_productThumbSlider.slideTo(0, 300)
        }
    }

    // ----- js_product_slider end

    $('.js_sliderCarousel__navigation').each(function () {

        let prev = $(this).find('.swiper-button-prev.swiper-button-disabled').length > 0
        let next = $(this).find('.swiper-button-next.swiper-button-disabled').length > 0

        if (prev && next) {
            $(this).find('.swiper-button-disabled').css('opacity', 0);

        } else {
            $(this).find('.swiper-button-disabled').removeAttr('style');
        }
    })

    // =========================
    // ----- sliders end


    // ----- foto-gallery
    $('.js_gallery').off('click').photoSwipe('img', {
        bgOpacity: 0.7,
        mainClass: "pswp--imgOpen",
        // shareEl: false,
    });
    // ----- foto-gallery end


    // ----- custom-select

    $('.js_newSelect').find('.new-select__wrap').each(function () {
        let $select = $(this);
        let $option = $select.find('.new-select__option');
        let classes = $select.attr('class');
        let icn = '<i class="fal fa-angle-down"></i>'
        let placeholder = $select.data('placeholder');
        let optionsLength = $select.find('.new-select__option').length;
        setTimeout(function () {
            if (localStorage.getItem('activeHref') !== null) {
                let windowHref = window.location.pathname;
                if (windowHref = localStorage.activeHref) {
                    $('a.new-select__option').removeClass('is_selected');
                    $('a.new-select__option[href="' + windowHref + '"]').addClass('is_selected');
                }
            }

            if (placeholder == '' || placeholder === undefined) {
                placeholder = $select.parent().find('.new-select__body .new-select__option.is_selected').html();
            }
            $select.parent().find('.new-select__head--txt').html(placeholder);
            $select.parent().find('.new-select__body').css({'--length': optionsLength});
        }, 1);

        if ($select[0].tagName == 'SELECT') {
            $select.removeAttr('class').parents('.js_newSelect').addClass('is_select');
            $select.wrap(`<div class="${classes}"></div>`);

            let template = `<div class="new-select__head">
    							<div class="new-select__head--txt">${placeholder}</div>
    							<div class="new-select__head--icn">${icn}</div>
    						</div>
    						<div class="new-select__body">`

            $select.find('option').each(function (item, elem) {
                let optionHtml = $(this).html();
                let attrs = $(this)[0].attributes;
                let output = '';
                for (var i = attrs.length - 1; i >= 0; i--) {
                    output += `${attrs[i].name}="${attrs[i].value}"`;
                }
                template += `<div ${output}  style="--index: ${item}">${optionHtml}</div>`;
            });

            template += `</div>`;
            $select.after(template);
            $select.on('change', function () {
                let $select__optionTxt = $('option:selected', this).text();
                let $select__optionValue = $('option:selected', this).attr('value');

                $(this).parent().find('.new-select__head--txt').text($select__optionTxt);
                $(this).parent().find('.new-select__option').removeClass('is_selected');
                $(this).parent().find(`.new-select__option[value="${$select__optionValue}"]`).addClass('is_selected');
            });

            $select.removeClass('visually-hidden');
            $select.parents('.js_newSelect').removeClass('is_open').addClass('is_mobile');
        }
    });

    $('.new-select__head, .new-select__label, .js_newSelect select').on("click", function (e) {
        $('html').one('click', function () {
            $('.js_newSelect').removeClass('is_open');
        });
        $(this).parents('.js_newSelect').toggleClass('is_open');
        e.stopPropagation();
    });

    $('body').on("click", `.new-select__option`, function (e) {
        e.preventDefault();

        $(this).parents('.new-select__wrap').find('.new-select__option').removeClass('is_selected');
        $(this).addClass('is_selected');
        $(this).parents('.js_newSelect').removeClass('opened');

        $(this).parents('.new-select__wrap').find('select').val($(this).attr('value')).trigger('change');

        if ($(this).parents('.js_newSelect').hasClass('is_change')) {
            $(this).parents('.js_newSelect').find('.new-select__head--txt').html($(this).html());
        } else if ($(this).parents('.js_newSelect').hasClass('is_select')) {
            // location = $(this).attr('value');
        } else {
            localStorage.activeHref = this.getAttribute('href');
            location = $(this).attr('href');
        }
    });

    let thisQuantity = $(this).data('preorder-quantity')
    let newthisQuantity;
    thisQuantity >= 10 ? thisQuantity = 10 : thisQuantity
    if (thisQuantity > 0) {
        let seltectTemplate = '';
        let customSeltectTemplate = '';
        for (var i = 1; i <= thisQuantity; i++) {
            seltectTemplate += `<option class="new-select__option" value="${i}">${i}</option>`
            customSeltectTemplate += `<div value="${i}" class="new-select__option" style="--index: ${i}">${i}</div>`
        }

        $('.new-select_quantity').find('.new-select__head--txt').text('1')
        $('.new-select_quantity').find('.new-select__body').css({'--length': thisQuantity}).html(customSeltectTemplate)
        $('.new-select_quantity').find('select').html(seltectTemplate)
    }

    // ----- custom-select END

    // $('[data-preorder-quantity]').trigger('click');

    if ($('#input-option > *').length > 9) {
        $('#input-option').addClass('is_hide')
    }
    $('body').on('click', '#input-option', function () {
        $(this).addClass('is_open')
    })

    $('.form-box').parsley();

    $('body').on('change', '.js_checkbox', function () {

        $input = $(this).find('input[type="checkbox"]');
        $input.toggleClass('is_checked');
        $input.attr('checked', $input.attr('checked') === 'checked' ? false : 'checked');
    });

    $('body').on('click', '.js_checkPassword', function () {
        let $input = $(this).parent().find('.js_inputPassword');
        let $icon = $(this).find('i');
        $icon.attr('class', $icon.attr('class') === 'fad fa-eye' ? 'fad fa-eye-slash' : 'fad fa-eye');
        $input.attr('type', $input.attr('type') === 'password' ? 'text' : 'password');
    });

    // ----- simple-tap
    $(".js_simpleTap__btn").click(function () {
        const $parent = $(this).parents('.js_simpleTap');
        $parent.find(".js_simpleTap__btn").removeClass("is_active").eq($(this).index()).addClass("is_active");
        $parent.find(".js_simpleTap__content").removeClass('is_show').addClass('is_hide').eq($(this).index()).addClass('is_show').removeClass('is_hide')
    }).eq(0).addClass("active");
    // ----- simple-tap end


    $('[data-show="form-review"]').on('click', function () {
        var fromReview = $('[data-form="review"]')
        var formOffset = fromReview.parent().offset().top;
        $(this).remove()
        $('html, body').animate({scrollTop: formOffset}, 700, function () {
            fromReview.slideDown(500)
        });

    });

    // ----- quantity plus and minus
    (function () {
        const $domTags = $('body');
        const js_priceTotal = $('.js_priceTotal');
        const js_priceTotalVal = parseFloat(js_priceTotal.text().match(/[\d|,|.|e|E|\+]+/g));
        const currency = $('.js_priceTotal').text().charAt(0);
        const formatter = new Intl.NumberFormat({
            maximumSignificantDigits: 3,
        });

        $($domTags).on('click', '.js_quantityPlus', function () {
            if ($(this).prev().val()) {
                $(this).prev().val(+$(this).prev().val() + 1);

                let js_newPriceTotalVal = parseFloat(js_priceTotal.text().match(/[\d|,|.|e|E|\+]+/g));
                let js_newPriceTotal = js_priceTotalVal * $(this).prev().val();
                // js_priceTotal.html(currency + formatter.format(js_newPriceTotal));
            }
        });
        $($domTags).on('click', '.js_quantityMinus', function () {
            if ($(this).next().val() > 1) {
                if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);

                let js_newPriceTotalVal = parseFloat(js_priceTotal.text().match(/[\d|,|.|e|E|\+]+/g));
                let js_newPriceTotal = js_priceTotalVal * $(this).next().val();
                // js_priceTotal.html(currency + formatter.format(js_newPriceTotal));
            }
        });

        $($domTags).on('keyup keypress', '.js_quantityNumber', function (event) {
            event = event || window.event;
            if (event.charCode && event.charCode != 0 && event.charCode != 46 && (event.charCode < 48 || event.charCode > 57))
                return false;

            let val = $(this).val();
            if (val > 0) {
                let js_newPriceTotalVal = parseFloat(js_priceTotal.text().match(/[\d|,|.|e|E|\+]+/g));
                let js_newPriceTotal = js_priceTotalVal * $(this).val();
                // js_priceTotal.html(currency + formatter.format(js_newPriceTotal));
            }
        });

        $($domTags).on('blur', '.js_quantityNumber', function () {
            let val = $(this).val();
            if (val <= 0) {
                $(this).val(1);
            }
            let js_newPriceTotalVal = parseFloat(js_priceTotal.text().match(/[\d|,|.|e|E|\+]+/g));
            let js_newPriceTotal = js_priceTotalVal * $(this).val();
            // js_priceTotal.html(currency + formatter.format(js_newPriceTotal));
        });


        // option calc
        // $('.b-check').find('input').change(function () {
        //     if ($(this).prop('checked')) {
        //
        //     } else {
        //
        //     }
        // });
        // option calc End


    })();
    // ----- quantity plus and minus

    $('body').on('click', '.basket-item__remove--btn', function () {
        const $this = $(this)

        let template = `<div class="b-alert is-hidden js_alert_remove">
                        <div class="b-alert__close js_alertClose">
                            <i class="fal fa-times b-alert__close--icn"></i>
                        </div>
                        <div class="b-alert__head">Are you sure?</div>
                        <div class="b-alert__body">
                            <div class="b-alert__txt">Click yes to delete the item</div>
                            <div class="elms elms_center b-alert__elms">
                                <button class="btn btn_yes js_btnYes b-alert__btn">Yes</button>
                                <button class="btn btn_cancel js_btnCancel b-alert__btn">Cancel</button>
                            </div>
                        </div>
                    </div>`
        $('.b-alerts-hide').append(template)

        setTimeout(function () {
            $('.js_alert_remove').removeClass('is-hidden');
        }, 1);


        $('.js_btnYes').on('click', function () {
            $('.js_alertClose').click();
            update_cart($this, 'remove');
        });


    });

    $('body').on('click', '.modalwindow', function (e) {
        e.stopPropagation()
    });

    $('.js_alertClose, .js_btnCancel, body').on('click', function () {
        closePP();
    });

    $('body').on('click', '#smca-modal-data + .mfp-close', function () {
        closePP();
    });

    // if ($('.review').find('.review-item').length === 0) {
    //     $('[data-show="form-review"]').remove();
    //     $('.js_no-review').append('<span style="color: #aaa; margin-left: 3px; font-size: 12px;">(0)</span>');
    //     $('.review__body--form').css({'padding-top': '5px'});
    //     $('[data-form="review"]').css({'display': 'block'});
    // }

    // ----- triggers
    setTimeout(() => {
        js_pageScroll.trigger('scroll');
        js_pageScroll.trigger('resize');
    }, 0)
    // ----- triggers end
});

function closePP() {
    $('.js_alert_remove').addClass('is-hidden');
    setTimeout(function () {
        $('.js_alert_remove').remove()
    }, 600);
}

// ----- auto textarea height
function auto_grow(element) {
    element.style.height = "55px";
    element.style.height = (element.scrollHeight) + "px";
}

// ----- auto textarea height end

// ----- lazy image
document.addEventListener("DOMContentLoaded", function () {
    var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;


                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.srcset = lazyImage.dataset.srcset;
                    lazyImage.classList.remove("lazy");

                    lazyImageObserver.unobserve(lazyImage);


                }
            });
        });

        lazyImages.forEach(function (lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    } else {
        // Possibly fall back to event handlers here
    }
});

// ----- lazy image end

function addDoubleProduct(product_id, quantity, options) {
    $.ajax({
        url: 'index.php?route=checkout/cart/addDoubleProduct',
        type: 'post',
        data: 'product_id=' + product_id + '&quantity=' + (typeof (quantity) != 'undefined' ? quantity : 1) + "&" + options,
        dataType: 'json',
        success: function (json) {
            if (json['redirect']) {
                location = json['redirect'];
            }
        },
        error: function (xhr, ajaxOptions, thrownError) {
            alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
    });
}

function checkFlexGap() {
    // create flex container with row-gap set
    var flex = document.createElement("div");
    flex.style.display = "flex";
    flex.style.flexDirection = "column";
    flex.style.rowGap = "1px";

    // create two, elements inside it
    flex.appendChild(document.createElement("div"));
    flex.appendChild(document.createElement("div"));

    // append to the DOM (needed to obtain scrollHeight)
    document.body.appendChild(flex);
    var isSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
    flex.parentNode.removeChild(flex);

    return isSupported;
}

if (checkFlexGap()) {
    document.documentElement.classList.add('is_flex-gap');
} else {
    document.documentElement.classList.add('no_flex-gap');
}

// hide popup chat btn
setInterval(() => {
    if (document.querySelector('.mfp-wrap')) {
            if(document.querySelector('.crisp-client')) {
                document.querySelector('.crisp-client').style.display = 'none';
            }
        document.querySelector('#preezie-widget-div-id-popup2').style.display = 'none';
    } else {
        if (document.querySelector('.crisp-client')) {
            document.querySelector('.crisp-client').style.display = 'block';
        }
        document.querySelector('#preezie-widget-div-id-popup2').style.display = 'block';
    }
}, 1000)

 const selectors = [
     document.querySelector('#common-success'),
     document.querySelector('#account-forgotten'),
     document.querySelector('#information-sitemap')
 ]

selectors.forEach((elem) => {
    if (elem !== null) {
        document.querySelector('.footer').classList.add('account-created-success__footer');
        document.querySelector('.footer').classList.remove('footer');
    }
});

// if (window.matchMedia('(max-width: 865px)').matches) {
//     $('.js_icons_append_mobile').appendTo($('.js_love-it__body'));
// }

// if ($('.love-it')) {
//     $('.love-it').hasClass('is_active') || $('.descr').addClass('is_active')
// }

if (document.querySelector('.review-item ')) {
    $('.review').addClass('is_active', 'is_open')
}
